import { Form } from '@anytag/shared-atoms';
import { useUpdatePackageProposal } from '../hooks';
import { formatPackageProposedInfluencersRowsData } from '../utils';
import { ProposeInfluencersFormValues } from '../../../Influencers';
import { usePackageProposalContext } from '../PackageProposalContext';
import { Template, TemplateProps } from './Template';
import { usePackageContentInfluencersSearch } from './hooks';

export type PackageContentListProps = Omit<TemplateProps, 'data'>;

export const PackageContentList = (props: PackageContentListProps) => {
  const { packageInfluencers, proposalSummary } = usePackageProposalContext();
  const { jdMode, isEditMode } = usePackageContentInfluencersSearch();
  const { handleSaveProposal } = useUpdatePackageProposal({ packageId: proposalSummary?.id || 0, jdMode });

  const { tableData, formValues } = formatPackageProposedInfluencersRowsData(packageInfluencers, jdMode, isEditMode);

  return (
    <Form.Provider<ProposeInfluencersFormValues>
      values={formValues}
      onSubmit={handleSaveProposal(tableData)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submit on Enter key, user needs to click the Save button
        }
      }}
    >
      <Template {...props} data={tableData} />
    </Form.Provider>
  );
};

export * from './PackageSummary';
export * from './types';
export { usePackageContentInfluencersSearch } from './hooks';
